import {useQuery} from 'react-query';
import {getBrandSaleAgent} from '.';

const useGetBrandSaleAgent = (brandId: number) => {
  const {data, isLoading} = useQuery({
    queryKey: ['brand-sale-agent'],
    queryFn: () => getBrandSaleAgent(brandId),
    cacheTime: 0,
  });

  return {data, isLoading};
};

export default useGetBrandSaleAgent;
